// A full raid roster. Drives the schedule grid's raid-ready threshold and the setup
// panel's total-count rule — change it here and both agree.
export const RAID_SIZE = 20;
